import { add, sub, div } from '@/utils/accurateNumber'
import { region } from '@/utils/utils'

/**
 * @description: 马来/菲律宾国家显示 税前价格、税率价格
 * @param { number} proces  // 价格
 * @param { number} taxRate  // 税率
 * @return { Object } displayMoney：价格，displayTrProce：税率
 */

const TAX_COUNTRY_MAP = {
  my: {
    unit: 'SST',
  },
  ph: {
    unit: 'GST',
  },
}

export const TAX_COUNTRY_ARR = Object.keys(TAX_COUNTRY_MAP)

export const taxPriceFunc = (proces = '', taxRate = 0) => {
  let preProce = 0
  let taxProce = 0
  let country = region()

  proces = Number(proces)
  taxRate = add(1, taxRate)

  if (
    TAX_COUNTRY_ARR.includes(country.toLowerCase()) &&
    taxRate > 1 &&
    proces
  ) {
    preProce = Number(div(proces, taxRate).toFixed(2))
    taxProce = sub(proces, preProce)

    return {
      displayMoney: preProce,
      displayTrProce: taxProce,
      displayUnit: TAX_COUNTRY_MAP[country].unit,
    }
  }

  return {
    displayMoney: proces,
    displayTrProce: taxProce,
  }
}
